interface Options {
  element: HTMLIgwsGridElement | HTMLIgwsImgBgElement;
  isAdaptive: string;
  media_src: string[];
}

export function lazyImageBackground(options: Options) {
  const { element, isAdaptive, media_src } = options;
  if (element) {
    const observer = new IntersectionObserver(imageEntities => {
      imageEntities.forEach(image => {
        if (image.isIntersecting) {
          const imgRoot = image.target as HTMLImageElement;
          observer.unobserve(imgRoot);

          const dataSrc: string = imgRoot.dataset.src || '';
          let src: string =
            dataSrc ||
            (imgRoot.style &&
              imgRoot.style.backgroundImage &&
              imgRoot.style.backgroundImage
                .replace('url(', '')
                .replace(')', '')) ||
            '';
          let media: string[] = [];
          let mediaSrc: string[] = [];
          if (isAdaptive === 'true') {
            media = [
              '(min-width: 1px)',
              '(min-width: 320px)',
              '(min-width: 321px)',
              '(min-width: 481px)',
              '(min-width: 769px)',
              '(min-width: 1025px)',
            ];
            mediaSrc = media_src;
          }

          media.forEach((m, i) => {
            if (
              window.matchMedia(m.trim()).matches &&
              src !== mediaSrc[i].trim()
            ) {
              src = mediaSrc[i].trim();
            }
          });

          if (src) {
            const preloaderImg = document.createElement('img');
            preloaderImg.src = src;
            preloaderImg.onload = () => {
              imgRoot.style.backgroundImage = `url("${src}")`;
            };
          }
          delete imgRoot.dataset.src;
        }
      });
    }, {});

    observer.observe(element);
  }
}
